import type { LucideIcon } from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';

import { cn } from '@/lib/utils';

const sizeClasses = {
  xs: 'w-3.5 h-3.5',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
  xl: 'w-8 h-8',
};

export type AprilPictoSize = keyof typeof sizeClasses;

export interface AprilPictoProps extends Omit<SVGProps<SVGSVGElement>, 'ref'> {
  /** Picto SVG (import `?react`) ou icône lucide. */
  icon: ComponentType<SVGProps<SVGSVGElement>> | LucideIcon;
  size?: AprilPictoSize;
  inverted?: boolean;
}

export default function AprilPicto({ icon: Icon, size = 'md', inverted = false, className, ...props }: AprilPictoProps) {
  return (
    <Icon
      className={cn(
        sizeClasses[size] || sizeClasses.md,
        inverted && 'brightness-0 invert',
        className
      )}
      aria-hidden="true"
      {...props}
    />
  );
}
